import { tv } from "../../variants/tv.js";
const inclusionVariants = tv({
    slots: {
        inclusionSlot: 'flex items-center gap-1',
        textSlot: 'text-body3 text-neutral-13',
        iconSlot: 'text-neutral-13 inline-block transition',
        inclusionIconSlot: 'text-neutral-13 inline-block transition'
    },
    variants: {
        size: {
            sm: {
                textSlot: 'text-body3'
            },
            md: {
                textSlot: 'text-body2'
            }
        },
        type: {
            included: {
                iconSlot: 'text-benefit-8'
            },
            paid: {
                iconSlot: 'text-neutral-13',
                textSlot: 'text-neutral-13'
            },
            excluded: {
                textSlot: 'text-neutral-10',
                iconSlot: 'text-neutral-10',
                inclusionIconSlot: 'text-neutral-10'
            },
            unknown: {
                iconSlot: 'text-neutral-7',
                textSlot: 'text-neutral-10',
                inclusionIconSlot: 'text-neutral-7'
            }
        },
        customIcon: {
            true: {
                iconSlot: 'fill'
            }
        }
    },
    compoundVariants: [
        {
            customIcon: true,
            size: 'sm',
            class: {
                iconSlot: 'ml-[-2px]'
            }
        },
        {
            customIcon: true,
            size: 'md',
            class: {
                iconSlot: 'ml-[-4px]'
            }
        }
    ],
    defaultVariants: {
        size: 'sm',
        type: 'included'
    }
});
const inclusionSizes = Object.keys(inclusionVariants.variants.size);
export { inclusionSizes, inclusionVariants };
